import './css/formreset.css';
import './css/site.css';
import './css/common.css';
import './css/filter.css';
import './css/spending.css';
import './css/upload.css';
import './css/feedback.css';
import './css/dashboard.css';
import './css/factsheet.css';
import './css/employee.css';
import './css/detailedDistrictReportStyles.css';
import './css/govtreport.css';
import "../node_modules/react-toggle/style.css";
import '../node_modules/react-tabs/style/react-tabs.css';
import "../node_modules/rc-slider/assets/index.css";
import '../node_modules/react-accessible-accordion/dist/fancy-example.css';
import './css/newVendorTab1.css';
import './css/submission.css';
import './css/viewReportModal.css';
import './images/IRISLogo_Portal.png';
import './images/cohort_clean.png';
import './css/iris-envision-future.png';
import './javascript/tabcontent.js';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import { BrowserRouter as Router } from "react-router-dom";

import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { PersistGate } from 'redux-persist/integration/react';
import { history } from './myhistory';

import { store, persistor } from "./store";
import { AppRoutes } from './routes';

function renderApp() {
    ReactDOM.render(
        <AppContainer>
            <Provider store={store}>
                <PersistGate persistor={persistor}>
                    <ConnectedRouter history={history}>
                        <AppRoutes />
                    </ConnectedRouter>
                </PersistGate>
            </Provider>
        </AppContainer>
        ,
        document.getElementById('react-app')
    );
}

renderApp();
